"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function MastercardSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 20, viewBox: "0 0 30 20" }, props),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { fill: "#FFF", fillRule: "nonzero", d: "M27.5.5c1.105 0 2 .895 2 2v15c0 1.105-.895 2-2 2h-25c-1.105 0-2-.895-2-2v-15c0-1.105.895-2 2-2h25zm0-.5h-25C1.12 0 0 1.12 0 2.5v15C0 18.88 1.12 20 2.5 20h25c1.38 0 2.5-1.12 2.5-2.5v-15C30 1.12 28.88 0 27.5 0z" }),
            react_1.default.createElement("path", { fill: "#E5E8F1", d: "M27.5.5c1.105 0 2 .895 2 2v15c0 1.105-.895 2-2 2h-25c-1.105 0-2-.895-2-2v-15c0-1.105.895-2 2-2h25z" }),
            react_1.default.createElement("path", { fill: "#FFC107", fillRule: "nonzero", d: "M26.045 9.79c0 3.64-3.125 6.585-7 6.585s-7-2.95-7-6.585 3.125-6.585 7-6.585 7 2.95 7 6.585z" }),
            react_1.default.createElement("path", { fill: "#FF3D00", fillRule: "nonzero", d: "M13.5 13.74c-.325-.404-.6-.846-.82-1.315h3.72c.196-.42.346-.862.445-1.315H12.24c-.094-.432-.14-.873-.14-1.315h4.89c0-.442-.048-.883-.14-1.315h-4.61c.1-.453.249-.894.445-1.315h3.72c-.22-.47-.495-.91-.82-1.315H13.5c.306-.387.653-.739 1.035-1.05C13.25 3.765 11.65 3.202 10 3.205c-3.855 0-7 2.95-7 6.585s3.125 6.585 7 6.585c2.163.016 4.215-.954 5.575-2.635H13.5z" })));
}
function Mastercard(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(MastercardSvg, Object.assign({}, svgProps)));
}
exports.default = Mastercard;
//# sourceMappingURL=Mastercard.js.map